import React, { useRef, useState } from 'react';
import { editarCampana } from './campanasApi';
import { E } from './estilos';
import { ACCEPT_CABECERA, nuevaClaveIdempotencia, programacionDemasiadoLejana } from '../../utils/campanas';
import { motivoDelError } from '../../utils/errores';

const AVISO_29_DIAS = 'Con cabecera multimedia la campaña se puede programar como mucho a 29 días';

/** Editar una campaña programada: nombre, fecha y, opcionalmente, un fichero nuevo. */
const EditarCampanaForm = ({ campana, onGuardada, onError, onCancelar }) => {
  const [nombre, setNombre] = useState(campana.nombre);
  const [modo, setModo] = useState('programar');
  const [fecha, setFecha] = useState(String(campana.programadaParaLocal || '').slice(0, 16));
  const [zona, setZona] = useState(campana.zonaHoraria);
  const [fichero, setFichero] = useState(null);
  const [cabecera, setCabecera] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const enviando = useRef(false);
  const claveIntento = useRef(null);
  const firmaPrevia = useRef(null);
  const firma = [nombre, modo, fecha, zona, fichero?.name, fichero?.size, cabecera?.name, cabecera?.size].join('\0');
  if (firmaPrevia.current !== firma) {
    firmaPrevia.current = firma;
    claveIntento.current = null;
  }

  const guardar = async () => {
    if (enviando.current) return;
    if (!nombre.trim()) {
      onError('Ponle un nombre a la campaña.');
      return;
    }
    if (modo === 'programar' && !fecha) {
      onError('Indica la fecha y la hora de envío.');
      return;
    }
    if (modo === 'programar' && campana.cabeceraFormato && programacionDemasiadoLejana(fecha, zona, new Date())) {
      onError(AVISO_29_DIAS);
      return;
    }
    const cuerpo = new FormData();
    cuerpo.append('nombre', nombre.trim());
    if (modo === 'programar') {
      cuerpo.append('programadaPara', fecha);
      cuerpo.append('zonaHoraria', zona);
    }
    if (fichero) cuerpo.append('fichero', fichero);
    if (cabecera) cuerpo.append('cabecera', cabecera);
    enviando.current = true;
    setGuardando(true);
    if (!claveIntento.current) claveIntento.current = nuevaClaveIdempotencia();
    const r = await editarCampana(campana.id, cuerpo, claveIntento.current);
    enviando.current = false;
    setGuardando(false);
    if (r.status !== 0) claveIntento.current = null;
    if (r.ok) {
      onGuardada(r.data);
      return;
    }
    onError(motivoDelError(r.status, r.data, 'No se pudo editar la campaña.'));
  };

  return (
    <div className="campanas" style={E.tarjeta}>
      <label style={E.campo}>
        <span style={E.etiqueta}>Nombre</span>
        <input style={E.input} value={nombre} maxLength={150} onChange={(e) => setNombre(e.target.value)} />
      </label>
      <div style={E.fila2}>
        <label>
          <input type="radio" name="modo-edicion" checked={modo === 'ahora'} onChange={() => setModo('ahora')} />
          {' '}Enviar ahora
        </label>
        <label>
          <input type="radio" name="modo-edicion" checked={modo === 'programar'} onChange={() => setModo('programar')} />
          {' '}Programar
        </label>
      </div>
      {modo === 'programar' && (
        <div className="campanas-row" style={E.fila2}>
          <label style={E.campo}>
            <span style={E.etiqueta}>Fecha y hora</span>
            <input type="datetime-local" style={E.input} value={fecha} onChange={(e) => setFecha(e.target.value)} />
          </label>
          <label style={E.campo}>
            <span style={E.etiqueta}>Zona horaria</span>
            <input style={E.input} value={zona} onChange={(e) => setZona(e.target.value)} />
          </label>
        </div>
      )}
      {campana.cabeceraFormato && (
        <>
          <p style={E.etiqueta}>{`Cabecera actual: ${campana.cabeceraNombre || ''}`}</p>
          <label style={E.campo}>
            <span style={E.etiqueta}>Sustituir cabecera (opcional)</span>
            <input
              type="file"
              accept={ACCEPT_CABECERA[campana.cabeceraFormato]}
              onChange={(e) => setCabecera(e.target.files?.[0] || null)}
            />
          </label>
        </>
      )}
      <label style={E.campo}>
        <span style={E.etiqueta}>Fichero nuevo (opcional)</span>
        <input type="file" accept=".xlsx,.csv" onChange={(e) => setFichero(e.target.files[0] || null)} />
      </label>
      <div className="campanas-acciones" style={E.fila2}>
        <button type="button" style={E.btnPrimary} disabled={guardando} onClick={guardar}>
          {guardando ? 'Guardando…' : 'Guardar cambios'}
        </button>
        <button type="button" style={E.btnGhost} onClick={onCancelar}>Descartar</button>
      </div>
    </div>
  );
};

export default EditarCampanaForm;
